import { getCustomExtraPathDashboard } from "@pages/Dashboard/helper";
import services from "@src/Services";

export const getNotificationCount = async (filters: FilterType) => {
  try {
    const advancedFilterExtraPath = getCustomExtraPathDashboard({ ...filters });

    const customPath = `${advancedFilterExtraPath}`;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const res: any = await services.get(
      `/unread-notification-count${customPath}`
    );
    if (!res?.error) {
      return { data: res?.data?.data };
    }
    return { data: null, error: "Something went wrong !" };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    return {
      error: err?.error?.message || "Something went wrong!",
    };
  }
};
